/* eslint-disable */

export const tags = {
  "mj-accordion": {
    attrs: {
      border: null,
      "container-background-color": null,
      "css-class": null,
      "font-family": null,
      "icon-align": null,
      "icon-height": null,
      "icon-position": null,
      "icon-unwrapped-alt": null,
      "icon-unwrapped-url": null,
      "icon-width": null,
      "icon-wrapped-alt": null,
      "icon-wrapped-url": null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
    },
  },
  "mj-accordion-element": {
    attrs: {
      "background-color": null,
      border: null,
      "css-class": null,
      "font-family": null,
      "icon-align": null,
      "icon-height": null,
      "icon-position": null,
      "icon-unwrapped-alt": null,
      "icon-unwrapped-url": null,
      "icon-width": null,
      "icon-wrapped-alt": null,
      "icon-wrapped-url": null,
    },
  },
  "mj-accordion-title": {
    attrs: {
      "background-color": null,
      color: null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-weight": null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
    },
  },
  "mj-accordion-text": {
    attrs: {
      "background-color": null,
      color: null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-weight": null,
      "letter-spacing": null,
      "line-height": null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
    },
  },
  "mj-all": {},
  "mj-attributes": {},
  "mj-breakpoint": {},
  "mj-button": {
    attrs: {
      align: null,
      "background-color": null,
      border: null,
      "border-bottom": null,
      "border-left": null,
      "border-radius": null,
      "border-right": null,
      "border-top": null,
      color: null,
      "container-background-color": null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-style": null,
      "font-weight": null,
      height: null,
      href: null,
      "inner-padding": null,
      "letter-spacing": null,
      "line-height": null,
      name: null,
      padding: null,
      "padding-top": null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      rel: null,
      target: null,
      "text-align": null,
      "text-decoration": null,
      "text-transform": null,
      title: null,
      "vertical-align": null,
      width: null,
    },
  },
  "mj-carousel": {
    attrs: {
      align: null,
      "border-radius": null,
      "container-background-color": null,
      "css-class": null,
      "icon-width": null,
      "left-icon": null,
      padding: null,
      "padding-top": null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "right-icon": null,
      "tb-border": null,
      "tb-border-radius": null,
      "tb-hover-border-color": null,
      "tb-selected-border-color": null,
      "tb-width": null,
      thumbnails: null,
    },
  },
  "mj-carousel-image": {
    attrs: {
      alt: null,
      "border-radius": null,
      "css-class": null,
      href: null,
      rel: null,
      src: null,
      target: null,
      "tb-border": null,
      "tb-border-radius": null,
      "thumbnails-src": null,
      title: null,
    },
  },
  "mj-class": {
    attrs: {
      name: null,
    },
  },
  "mj-column": {
    attrs: {
      "background-color": null,
      border: null,
      "border-bottom": null,
      "border-left": null,
      "border-radius": null,
      "border-right": null,
      "border-top": null,
      "css-class": null,
      direction: null,
      "inner-background-color": null,
      "inner-border": null,
      "inner-border-bottom": null,
      "inner-border-left": null,
      "inner-border-radius": null,
      "inner-border-right": null,
      "inner-border-top": null,
      padding: null,
      "padding-top": null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "vertical-align": null,
      width: null,
    },
  },
  "mj-divider": {
    attrs: {
      align: null,
      "border-color": null,
      "border-style": null,
      "border-width": null,
      "container-background-color": null,
      "css-class": null,
      padding: null,
      "padding-top": null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      width: null,
    },
  },
  "mj-font": {
    attrs: {
      href: null,
      name: null,
    },
  },
  "mj-group": {
    attrs: {
      "background-color": null,
      "css-class": null,
      direction: null,
      "vertical-align": null,
      width: null,
    },
  },
  "mj-hero": {
    attrs: {
      "background-color": null,
      "background-height": null,
      "background-position": null,
      "background-url": null,
      "background-width": null,
      "border-radius": null,
      "css-class": null,
      height: null,
      "inner-background-color": null,
      "inner-padding": null,
      "inner-padding-bottom": null,
      "inner-padding-left": null,
      "inner-padding-right": null,
      "inner-padding-top": null,
      mode: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      "vertical-align": null,
    },
  },
  "mj-html-attribute": {},
  "mj-html-attributes": {},
  "mj-image": {
    attrs: {
      alt: null,
      align: null,
      border: null,
      "border-bottom": null,
      "border-left": null,
      "border-radius": null,
      "border-right": null,
      "border-top": null,
      "container-background-color": null,
      "css-class": null,
      "fluid-on-mobile": null,
      "font-size": null,
      height: null,
      href: null,
      "max-height": null,
      name: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      rel: null,
      sizes: null,
      src: null,
      srcset: null,
      target: null,
      title: null,
      usemap: null,
      width: null,
    },
  },
  "mj-navbar": {
    attrs: {
      align: null,
      "base-url": null,
      "css-class": null,
      hamburger: null,
      "ico-align": null,
      "ico-close": null,
      "ico-color": null,
      "ico-font-family": null,
      "ico-font-size": null,
      "ico-line-height": null,
      "ico-open": null,
      "ico-padding": null,
      "ico-padding-bottom": null,
      "ico-padding-left": null,
      "ico-padding-right": null,
      "ico-padding-top": null,
      "ico-text-decoration": null,
      "ico-text-transform": null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
    },
  },
  "mj-navbar-link": {
    attrs: {
      color: null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-style": null,
      "font-weight": null,
      href: null,
      "letter-spacing": null,
      "line-height": null,
      name: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      rel: null,
      target: null,
      "text-decoration": null,
      "text-transform": null,
    },
  },
  "mj-preview": {},
  "mj-section": {
    attrs: {
      "background-color": null,
      "background-position": null,
      "background-position-x": null,
      "background-position-y": null,
      "background-repeat": null,
      "background-size": null,
      "background-url": null,
      border: null,
      "border-bottom": null,
      "border-left": null,
      "border-radius": null,
      "border-right": null,
      "border-top": null,
      "css-class": null,
      direction: null,
      "full-width": null,
      gutter: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      "text-align": null,
    },
  },
  "mj-selector": {},
  "mj-social": {
    attrs: {
      align: null,
      border: null,
      "border-radius": null,
      color: null,
      "container-background-color": null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-style": null,
      "font-weight": null,
      "icon-height": null,
      "icon-padding": null,
      "icon-size": null,
      "inner-padding": null,
      "line-height": null,
      mode: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      "text-decoration": null,
      "text-padding": null,
    },
  },
  "mj-social-element": {
    attrs: {
      align: null,
      alt: null,
      "background-color": null,
      border: null,
      "border-radius": null,
      color: null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-style": null,
      "font-weight": null,
      href: null,
      "icon-height": null,
      "icon-padding": null,
      "icon-position": null,
      "icon-size": null,
      "line-height": null,
      name: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      rel: null,
      sizes: null,
      src: null,
      srcset: null,
      target: null,
      "text-decoration": null,
      "text-padding": null,
      title: null,
      "vertical-align": null,
    },
  },
  "mj-spacer": {
    attrs: {
      "container-background-color": null,
      "css-class": null,
      height: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
    },
  },
  "mj-style": {
    attrs: {
      inline: null,
    },
  },
  "mj-table": {
    attrs: {
      align: null,
      border: null,
      cellpadding: null,
      cellspacing: null,
      color: null,
      "container-background-color": null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "line-height": null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      role: null,
      "table-layout": null,
      width: null,
    },
  },
  "mj-text": {
    attrs: {
      align: null,
      color: null,
      "container-background-color": null,
      "css-class": null,
      "font-family": null,
      "font-size": null,
      "font-style": null,
      "font-weight": null,
      height: null,
      "letter-spacing": null,
      "line-height": null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      "text-decoration": null,
      "text-transform": null,
    },
  },
  "mj-title": {},
  "mj-wrapper": {
    attrs: {
      "background-color": null,
      "background-position": null,
      "background-position-x": null,
      "background-position-y": null,
      "background-repeat": null,
      "background-size": null,
      "background-url": null,
      border: null,
      "border-bottom": null,
      "border-left": null,
      "border-radius": null,
      "border-right": null,
      "border-top": null,
      "css-class": null,
      "full-width": null,
      gap: null,
      padding: null,
      "padding-bottom": null,
      "padding-left": null,
      "padding-right": null,
      "padding-top": null,
      "text-align": null,
    },
  },
};

export function completeAfter(CodeMirror, cm, pred) {
  var cur = cm.getCursor();
  if (!pred || pred())
    setTimeout(function () {
      if (!cm.state.completionActive)
        cm.showHint({
          completeSingle: false,
          schemaInfo: tags,
          tags: "mjml",
        });
    }, 100);
  return CodeMirror.Pass;
}

export function completeIfAfterLt(CodeMirror, cm) {
  return completeAfter(CodeMirror, cm, function () {
    var cur = cm.getCursor();
    return cm.getRange(CodeMirror.Pos(cur.line, cur.ch - 1), cur) == "<";
  });
}

export function completeIfInTag(CodeMirror, cm) {
  return completeAfter(CodeMirror, cm, function () {
    var tok = cm.getTokenAt(cm.getCursor());
    if (
      tok.type == "string" &&
      (!/['"]/.test(tok.string.charAt(tok.string.length - 1)) ||
        tok.string.length == 1)
    )
      return false;
    var inner = CodeMirror.innerMode(cm.getMode(), tok.state).state;
    return inner.tagName;
  });
}
